import { get, post } from './httpClient';
import type { TimesheetData, Balances } from '../types';

export const timesheetService = {
  // Get timesheet for a specific employee and date
  getTimesheet: async (employeeId: string, date: string): Promise<TimesheetData> => {
    const response = await get<TimesheetData>(`/db/timesheet/employee_id/${employeeId}/date/${date}`);
    return response.data;
  },

  // Save timesheet
  saveTimesheet: async (employeeId: string, date: string, hours: Record<string, string[]>): Promise<void> => {
    await post('/db/timesheet', {
      employee_id: employeeId,
      date: date,
      hours: hours,
    });
  },

  // Get total hours/balances for an employee
  getBalances: async (employeeId: string): Promise<Balances> => {
    const response = await get<Balances>(`/db_special/total_hours/employee_id/${employeeId}`);
    return response.data;
  },
};
